import { ApplicationConfig, enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { environment } from '../environments/environment';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateCustomParserFormatter } from './services/NgbDateCustomParserFormatter.service';
import { MSAL_INSTANCE, MsalService } from '@azure/msal-angular';
import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgxUiLoaderModule, POSITION, SPINNER, PB_DIRECTION } from 'ngx-ui-loader';
import { provideToastr } from 'ngx-toastr';
import { provideRouter } from '@angular/router';
import { routes } from './app-routing.module';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

const ngxUiLoaderConfiguration = {
  bgsColor: 'transparent',
  bgsOpacity: 0.1,
  bgsPosition: POSITION.centerCenter,
  bgsSize: 50,
  bgsType: SPINNER.threeStrings,
  blur: 3,
  delay: 0,
  fgsColor: '#f05a00',
  fgsPosition: POSITION.centerCenter,
  fgsSize: 100,
  fgsType: SPINNER.threeStrings,
  gap: 24,
  masterLoaderId: 'master',
  overlayBorderRadius: '0',
  // "overlayColor": "#71717178",
  // "pbColor": "#FF9900",
  pbDirection: PB_DIRECTION.leftToRight,
  pbThickness: 3,
  hasProgressBar: true,
  maxTime: -1,
  minTime: 500,
  // logoUrl: '/assets/img/logo.png',
  logoSize: 0,
  logoPosition: POSITION.centerCenter,
};

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      // 'cc737eee-af8f-42f3-882d-d13c0dff8456', //client ID svil
      // 'http://localhost:4200', //redirectUri svil
      // '565808a1-007c-4549-8014-6c809a03bfcc', //client ID test (dsspoc)
      // 'https://dsspoc.par-tec.it/mastercontrol', //redirectUri test (dsspoc)
      clientId: 'cc737eee-af8f-42f3-882d-d13c0dff8456',
      redirectUri: '/',
      postLogoutRedirectUri: '/',
      authority: 'https://login.microsoftonline.com/78a21ea1-f82c-406b-9699-7cff801991fe',
    },
  });
}

if (environment.production) {
  enableProdMode();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    provideToastr({
      preventDuplicates: true,
    }),
    importProvidersFrom(NgxUiLoaderModule.forRoot(ngxUiLoaderConfiguration)),
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
    { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory },
    MsalService,
  ],
};
